export const environment = {
  name: "production",
  enableProdMode: true,
  showHeaderVideo: true,
  BACKEND_API_URL: "/backend/",
  features: {
    hideEventSearchInDiscountManagement: true,
    hideAdvanceSearchInDiscountManagement: false,
    ForgotPasswordSendEmail: true,
    ModalWithBrotherAttributionAfterChildSave: true,
    brothersAttributionPage: true,
    collectiveRefund: true,
    newOpenReceiptPage: false,
    CollectiveRefundSecondApproval: true,
    ShowGetPaymentsSummary: true,
    userManagementPage: true,
    twoFactorLogin: true,
    twoFactorCodeCubes: true,
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts